import React, { useState, useContext } from "react";
import { AuthContext } from '../context/AuthContext'; // Import AuthContext
import "./SecurityModal.css";
import { getFirstTimePwdReset } from "../constants";

const SecurityModal = ({ isOpen, onClose, onSuccess }) => {
  const { userid } = useContext(AuthContext);
  const [securityQuestion, setSecurityQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const questions = [
    "What is your pet’s name?",
    "What is your mother’s maiden name?",
    "What was the name of your first school?",
  ];

  // ✅ Validate Password (8+ characters, 1 uppercase, 1 number, 1 special character)
  const validatePassword = (pwd) => {
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(pwd);
  };

  // ✅ Validate Answer (Only letters, numbers, single spaces, max 15 chars)
  const validateAnswer = (ans) => {
    return /^[A-Za-z0-9]+(?: [A-Za-z0-9]+)*$/.test(ans) && ans.length <= 15;
  };

  const handleSubmit = async () => {
    if (!securityQuestion) {
      setError("Please select a security question.");
      return;
    }
    if (!answer.trim()) {
      setError("Answer cannot be empty.");
      return;
    }
    if (!validateAnswer(answer)) {
      setError("Answer must be only letters and numbers, max 15 chars, single space allowed.");
      return;
    }
    if (!validatePassword(password)) {
      setError("Password must be 8+ chars, include an uppercase letter, a number, and a special character.");
      return;
    }
    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setError(""); // Clear any previous error

    try {
      const response = await fetch(getFirstTimePwdReset(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          empid: userid,
          password,
          security_question: securityQuestion,
          security_ans: answer,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        onSuccess(`Security details and Password are saved successfully!`); // Close the modal after success
      } else {
        setError(data.message || "Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      setError("Failed to connect to the server. Please try again later.");
    }
  };


  if (!isOpen) return null; // Hide modal when it's not open

  return (
    <div className="sm-modal-overlay">
      <div className="sm-modal-box">
        {/* Close Button */}
        <button className="sm-close-button" onClick={onClose}>✖</button>

        <h2>First Time Change Password</h2>

        {/* Security Question Dropdown */}
        <select
          className="sm-input-field sm-dropdown"
          value={securityQuestion}
          onChange={(e) => setSecurityQuestion(e.target.value)}
        >
          <option value="" disabled>Select a Security Question</option>
          {questions.map((q, index) => (
            <option key={index} value={q}>{q}</option>
          ))}
        </select>

        {/* Answer Field */}
        <input
          type="text"
          placeholder="Your Answer"
          className="sm-input-field"
          value={answer}
          onChange={(e) => setAnswer(e.target.value)}
        />

        {/* Password Fields */}
        <div className="fp-password-wrapper">
          <input
            type={showPassword ? "text" : "password"}
            placeholder="New Password"
            className="sm-input-field"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          /> <span
            className="fp-eye-icon"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? "👁️" : "🙈"}
          </span>
        </div>

        <div className="fp-password-wrapper">
          <input
            type={showConfirmPassword ? "text" : "password"}
            placeholder="Confirm Password"
            className="sm-input-field"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <span
            className="fp-eye-icon"
            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
          >
            {showConfirmPassword ? "👁️" : "🙈"}
          </span>
        </div>
        {/* Error Message */}
        {error && <p className="sm-error-text">{error}</p>}

        {/* Submit Button */}
        <button onClick={handleSubmit} className="sm-submit-button">Submit</button>
      </div >

    </div >

  );
};

export default SecurityModal;
